export const environment = {
  SHOW_CHRISTMAS_MESSAGE: false,
  PRODUCT_TYPES: ['top', 'bottom', 'hat', 'socks', 'accessories'],
  PRINT_PRICING: {
    text: 795,
    art: 895,
    upload: 995,
    namenumber: 795,
    maxPricePerSide: 1695,
  },
  FREE_SHIPPING_THRESHOLD: 600,
};
